// @ts-strict-ignore
import * as React from 'react';

import {Segmentation} from 'common/types/reports/query';
import {SelectedPropertyItem} from 'common/query-builder/query-block/properties-menu/types';
import {QueryBlockReact} from 'common/query-builder/query-block';
import {MenuType} from 'common/query-builder/query-block/types';
import {qbStyleAttrs} from 'common/query-builder/query-builder/util';
import {getIconForPropertyType} from 'common/report/util/properties';
import {ControlBarReact} from 'common/widgets/control-bar';
import {ButtonTheme} from 'common/components/button/constants';
import {
  ControlBarAction,
  ControlBarActionItems,
  ControlBarActionValue,
} from 'common/query-builder/query-entry-section/constants';
import {getPropertyType, setPropertyType} from 'common/query-builder/query-entry-section/row-types/row-util';
import {
  propertySelectionToSegmentation,
  segmentationToPropertySelection,
} from 'common/query-builder/query-block/segment-menu/util';
import {TypecastSubitem} from 'common/query-builder/query-entry-section/components/typecast-subitem';
import {EntryPart} from 'common/query-builder/query-entry-section/types';
import {PropertyType} from 'common/report/constants';
import {COMPUTED_LIST_PROPERTIES_VALUES} from 'common/query-builder/query-block/properties-menu/constants';
import {EntryRowProps} from 'common/query-builder/query-entry-section/row-types/types';
import {SelectorType} from 'common/query-builder/query-block/constants';

/** Value selection for list of objects breakdowns */
export function SegmentListObjectPropertySelector(
  props: EntryRowProps & {
    segment: Segmentation;
    numericOnly?: boolean;
    hideOverflowControls?: boolean;
    handleSelect: (selection: Segmentation) => void;
  },
) {
  const segmentPropertyName = props.segment.listItemGroup?.propertyName;
  const canTypecast =
    typeof segmentPropertyName === `string` && !COMPUTED_LIST_PROPERTIES_VALUES.has(segmentPropertyName);

  const propertyType = props.segment.listItemGroup && getPropertyType(props.segment.listItemGroup);
  const overflowControls = !props.hideOverflowControls && props.segment.listItemGroup?.propertyName && (
    <ControlBarReact
      key='entry-actions'
      elref='lineActions'
      theme={ButtonTheme.Tertiary}
      overflowIcon={props.hasNewUI ? `ellipsis` : `hor-ellipsis`}
      overflowControls={[
        {
          items: [canTypecast && ControlBarActionItems[ControlBarAction.Typecast](propertyType)].filter(Boolean),
        },
      ]}
      overflowMenuWidth={200}
      overflowMenuHeight={330}
      onSelect={(ev: CustomEvent) => {
        const value = ev.detail.value as ControlBarActionValue;

        if (value.action === ControlBarAction.Typecast) {
          props.handleSelect(setPropertyType(props.segment.listItemGroup, value.toType, false));
        }
      }}
    />
  );

  return (
    <>
      <div className='segment-list-object-property-selector'>
        <QueryBlockReact
          type={MenuType.Properties}
          eventNames={props.sectionProps.eventNames}
          disableValueSelection
          dataGroupId={props.sectionProps.dataGroupId}
          projectId={props.sectionProps.projectId}
          open={props.activePart === EntryPart.SubValue}
          selected={segmentationToPropertySelection(props.segment.listItemGroup)}
          theme={qbStyleAttrs(props.hasNewUI).selectorTheme}
          selectorType={SelectorType.Button}
          selectorIcon={getIconForPropertyType(propertyType) ?? ``}
          userId={props.sectionProps.userId}
          workspaceId={props.sectionProps.workspaceId}
          typeFilter={props.numericOnly ? [PropertyType.Number] : []}
          listProperty={props.segment}
          onSelect={(selection: SelectedPropertyItem) => {
            props.handleSelect(propertySelectionToSegmentation(selection.item) as Segmentation);
          }}
          onClose={() => props.setActivePart(EntryPart.SubValue, `close`)}
          onOpen={() => props.setActivePart(EntryPart.SubValue, `open`)}
        />
        <div className='actions'>{overflowControls}</div>
      </div>
      {props.segment.listItemGroup && (
        <TypecastSubitem value={props.segment.listItemGroup} onTypeChange={props.handleSelect} />
      )}
    </>
  );
}
